import { useEffect, useRef, useState } from 'react';
import moment from 'moment';

const TimeConverter = (props) => {

  // Props Destructuring
  const { date } = props  
  
  // State Management
  const intervalId = useRef(null);
 

  // React Hooks
  useEffect(() => {
    if (date) {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
      callbackRef.current = getTime;
      intervalId.current = setInterval(() => {
        const [time] = callbackRef.current();
        setTime(time);
      }, 1000);
    }
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [date]);

  // Methods
  const getTime = () => {
    const momentTime = moment.utc(date).local();
    const currentTime = moment();
    let difference = (currentTime - momentTime) / 1000;
    let dataRequired = `${difference.toFixed(0)}s`;
    if (difference < 0) {
      dataRequired = '0s' || `${difference.toFixed(0)}s`;
    } else if (difference > 3600) {
      difference /= (60 * 60);
      difference = Math.abs(Math.round(difference));
      dataRequired = `${difference}h+`;
    } else if (difference > 60) {
      difference = Math.floor(difference / 60);
      dataRequired = `${difference}m`;
    }
    return date ? [dataRequired] : '';
  };
  const callbackRef = useRef(getTime);
  const [Time, setTime] = useState(() => {
    const [time] = callbackRef.current();
    return time;
  });
  try {
    return Time;
  } catch (err) {
    console.log('err', err);
    return '';
  }
};

export default TimeConverter;
